// import {API_URL, X_API_KEY} from "../utils/apis.ts";
import {Division} from "./divisionService";
import {axiosL} from "../utils/axios.ts";

export type  Employee = {
    user_id: number,
    fname: string,
    mname?: string,
    lname: string,
    shop_floor_work_station: string,
    email: string,
    position: string,
    rank: string,
    role: string,
    jd: string,
    signature: string,
    work_station: string,
    tel: string,
    ip_phone: string,
    live_type: string,
    on_live: boolean,
    sSupervisor?: number,
    supervisor?: number,
    profile_photo?: string,
    department: number
    division?: number
    sub_department?: number
    unit?: number
    password?: string,
};

export type VehicleModel = {
    id: number;
  model_name: string;
  vehicle_type: string;
  image: string;
  year_make: string;
}

export type  EmployeeDB = {
    id: number,
    fname: string,
    mname: {
        "String": string,
        Valid: boolean,
    },
    lname: string,
    email: string,
    position: string,
    profile_photo: {
        "String": string,
        Valid: boolean,
    },
    jd: string,
    tel: string,
    iphone: string,
    shop_floor_work_station: string,
    work_station: string,
    sSupervisor: EmployeeDB,
    supervisor: EmployeeDB,
    rank: string,
    role: string,
    live_type: string,
    on_live: boolean,
    signature: string,
    department_id: number
    division_id: {
        Int64: number,
        Valid: boolean,
    },
    supervisor_l_id: {
        Int64: number,
        Valid: boolean,
    }
    s_supervisor_id: {
        Int64: number,
        Valid: boolean,
    }
    sub_department_id: {
        Int64: number,
        Valid: boolean,
    }
    unit_id: {
        Int64: number,
        Valid: boolean,
    }
    password: string,
};

export type AddEmployee = {
    fname: string,
    mname?: string,
    lname: string,
    email: string,
    position: string,
    signature?: string,
    shop_floor_work_station?: string,
    role?: string,
    rank: string,
    department: number
    division?: number
    sub_department?: number
    unit?: number
    password: string,
};

export type EmployeeLogin = {
    email: string,
    password: string,
}

export type EmployeeLoginL = {
    email: string,
}

export type EmployeeLoginOTP = {
    email: string,
    otp: string,
}


export const loginService = async (cred: EmployeeLogin) => {
    return await axiosL
            .post("login", {
                email: cred.email.trim(),
                password: cred.password.trim(),
            });
};

export const loginLService = async (cred: EmployeeLoginL) => {
    return await axiosL
        .post("generateOTP", {
            email: cred.email.trim(),
        });
};

export const loginOTPService = async (cred: EmployeeLoginOTP) => {
    return await axiosL
        .post("work_instructionLogin", {
            email: cred.email.trim(),
            otp: cred.otp.trim(),
        }, {withCredentials: true});
};


export const forgotPasswordService = async (email: string) => {
    return await axiosL
            .post("forgotPassword", {
                email: email.trim(),
            });
};

export const changePasswordService = async (token: string, password: string) => {
    return await axiosL
            .post(`changePassword/${token}`, {
                password: password.trim()
            });
};


export const signUpService = async (data_info: AddEmployee) => {
    return await axiosL
            .post("signUp", data_info)
};


export const LogoutService = async () => {
    return await axiosL
            .post("logout")
};

export const getEmployees = async () => {
    try {
        return await axiosL
            .get<EmployeeDB[]>("employees")
            .then(res => res.data);
    } catch (err) {}
};

export const getAllVehicleModels = async () => {
    try {
        return await axiosL
            .get<VehicleModel[]>("vehicle-models")
            .then(res => res.data);
    } catch (err) {}
}

export const getAllUsersBYDepartmentID = async (param: number) => {
    try {
        return await axiosL
            .get<EmployeeDB[]>(`department/${param.toString().trim()}/employees`)
            .then(res => res.data);
    } catch (err) {}
};

export const getAllUsersBYUnitID = async (param: number) => {
    try {
        return await axiosL
            .get<EmployeeDB[]>(`unit/${param.toString().trim()}/employees`)
            .then(res => res.data);
    } catch (err) {}
};

export const getAllUsersBYSubDepartmentID = async (param: number) => {
    try {
        return await axiosL
            .get<EmployeeDB[]>(`sub_department/${param.toString().trim()}/employees`)
            .then(res => res.data);
    } catch (err) {}
};

export const getAllUsersBYDivisionID = async (param: number) => {
    try {
        return await axiosL
            .get<EmployeeDB[]>(`division/${param.toString().trim()}/employees`)
            .then(res => res.data);
    } catch (err) {}
};

export const getAllUsersBYRole = async (param: string) => {
    try {
        return await axiosL
            .get<EmployeeDB[]>(`role/${param.trim()}/employees`)
            .then(res => res.data);
    } catch (err) {}
};

export const getEmployeesWithSupervisorID = async (param: number) => {
    try {
        return await axiosL
            .get<EmployeeDB[]>(`supervisor/${param.toString().trim()}/employees`)
            .then(res => res.data);
    } catch (err) {}
};

export const getEmployee = async (param: number) => {
    try {
        return await axiosL
            .get<EmployeeDB>("employees/" + param.toString().trim())
            .then(res => res.data);
    } catch (err) {}
};

export const uploadSignature = async (file: FormData, param: number) => {
    try {
        return await axiosL
        .post<string>(`upload/signature/${param}`, file).then(res => res.data);
    } catch (err) {}
}
